import { FC, ReactNode } from "react";
import { observer } from "mobx-react";
import { Box, CircularProgress } from "@mui/material";

import NotFoundPage from "./NotFoundPage";
import { useAppStore } from "../hooks/useAppStore";
import { useConfigFlagsWait } from "../hooks/useConfigFlagsWait";

/** Gates a ticketing route on AppStore.isTicketingEnabled without
 * flashing "Page Not Found" on reload/deep link while the flags are still
 * in flight over the WebSocket. If the flags never arrive, the page renders
 * anyway and the REST API stays the source of truth. */
const TicketingRoute: FC<{ children: ReactNode }> = observer(({ children }) => {
  const appStore = useAppStore();
  const { isWaiting, timedOut } = useConfigFlagsWait();

  if (isWaiting) {
    return (
      <main className="grow flex flex-col bg-hex-gray-100 h-[calc(100%-6rem)] overflow-y-auto overflow-x-hidden">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
            height: "100%",
            width: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      </main>
    );
  }

  if (!timedOut && !appStore.isTicketingEnabled) {
    return <NotFoundPage />;
  }

  return <>{children}</>;
});

export default TicketingRoute;
